export var FromDomin;
(function (FromDomin) {
    FromDomin["C_DOMAIN"] = "C_DOMAIN";
    FromDomin["B_DOMAIN"] = "B_DOMAIN";
})(FromDomin || (FromDomin = {}));
export var UType;
(function (UType) {
    UType["WECHAT"] = "wx";
    UType["WEWORK"] = "ww";
    UType["QQ"] = "qq";
})(UType || (UType = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["WEWORK"] = 2] = "WEWORK";
    UserType[UserType["WECHAT"] = 1] = "WECHAT";
})(UserType || (UserType = {}));
